import {
	Alert,
	AlertTitle,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select,
	Switch,
	TextField,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import {
	isEmptyObject,
	isEmptyString,
	isNullUndefined,
} from "../../../../util/util";
import {
	issueResponseMessage,
	issueWarnMessage,
} from "../../../../actions/message";
import Permit from "../../../../util/permit";
import { getSubscriptionBankAccounts } from "../../../../services/list.service";
import { saveCourt } from "../../../../services/courts.service";
import InputCharactersCountWrapper from "../../../inputs/inputCharactersCountWrapper";

/**
 *
 * REQUIRED PROPS
 *
 * handleSaveChanges
 * court
 *
 */

export default function CourtModal(props) {
	const [id, setId] = useState(null);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [mpesaPaybill, setMpesaPaybill] = useState("");
	const [mpesaBusinessShortcode, setMpesaBusinessShortcode] = useState("");
	const [mpesaKey, setMpesaKey] = useState("");
	const [mpesaSecret, setMpesaSecret] = useState("");
	const [mpesaPassKey, setMpesaPassKey] = useState("");
	const [apiInitiatorUsername, setApiInitiatorUsername] = useState("");
	const [apiInitiatorPassword, setApiInitiatorPassword] = useState("");
	const [nominatedNumber, setNominatedNumber] = useState("");
	const [bankAccountId, setBankAccountId] = useState("");
	const [useBankAccount, setUseBankAccount] = useState(false);
	const [useMpesa, setUseMpesa] = useState(false);
	const [useCustomPayInfo, setUseCustomPayInfo] = useState(false);
	const [customPayInstruction, setCustomPayInstruction] = useState("");
	const [payInvoice, setPayInvoice] = useState(false);
	const [hideBalanceBroughtForward, setHideBalanceBroughtForward] = useState(false);
	const [hideOutstandingAmount, setHideOutstandingAmount] = useState(false);
	const [disableSmsCommunication, setDisableSmsCommunication] = useState(false);
	const [attachStatement, setAttachStatement] = useState(false);
	const [subscriptionBankAccounts, setSubscriptionBankAccounts] = useState([]);
	const [showContactOnInvoice, setShowContactOnInvoice] = useState(false);
  const [invoiceContact, setInvoiceContact] = useState(null)
  const [invoiceEmail, setInvoiceEmail] = useState(null)

	useEffect(() => {
		if (!isEmptyObject(props.court)) {
			setId(props.court.id);
			setName(props.court.name);
			setDescription(props.court.description);
			if(!isNullUndefined(props.court.courtPayInfo) && !isEmptyObject(props.court.courtPayInfo)) {
				setBankAccountId(props.court.courtPayInfo.bankAccountId);
				setMpesaKey(props.court.courtPayInfo.mpesaKey);
				setMpesaPaybill(props.court.courtPayInfo.mpesaPaybill);
				setMpesaPassKey(props.court.courtPayInfo.mpesaPassKey);
				setApiInitiatorUsername(props.court.courtPayInfo.apiInitiatorUsername);
				setApiInitiatorPassword(props.court.courtPayInfo.apiInitiatorPassword);
				setNominatedNumber(props.court.courtPayInfo.nominatedNumber);
				setMpesaBusinessShortcode(
					props.court.courtPayInfo.mpesaBusinessShortcode
				);
				setMpesaSecret(props.court.courtPayInfo.mpesaSecret);
				setUseMpesa(props.court.courtPayInfo.useMpesa);
				setUseCustomPayInfo(props.court.courtPayInfo.useCustomPay);
				setCustomPayInstruction(
					props.court.courtPayInfo.customPayInstruction
				);
				setUseBankAccount(props.court.courtPayInfo.useBankAccount);
				setPayInvoice(props.court.courtPayInfo.payInvoice);
				setHideBalanceBroughtForward(
					props.court.courtPayInfo.hideBalanceBroughtForward
				);
				setHideOutstandingAmount(props.court.courtPayInfo.hideOutstandingAmount)
				setDisableSmsCommunication(props.court.courtPayInfo.disableSmsCommunication)
				setAttachStatement(props.court.courtPayInfo.attachStatement)
				if (
					!isNullUndefined(props.court.courtPayInfo.invoiceContacts) &&
					!isEmptyString(props.court.courtPayInfo.invoiceContacts.trim())
				) {
					setShowContactOnInvoice(true);
					props.court.courtPayInfo.invoiceContacts
					.split(", ")
					.map((c) => c.trim())
								.forEach(contact => {
						const phoneRegex = /^(07\d{8}|01\d{8}|\+2547\d{8}|\+2541\d{8})$/;
						if (phoneRegex.test(contact)) {
						setInvoiceContact(contact)
						return
						}
			
						const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
						if (emailRegex.test(contact)) {
						setInvoiceEmail(contact)
						}
					})
				}
			}
		}
	}, [props.court]);

	useEffect(() => {
		if (props.subscriptionOp) {
			getSubscriptionBankAccounts(props.subscriptionId).then(
				(subscriptionBankAccounts) =>
					setSubscriptionBankAccounts(subscriptionBankAccounts)
			);
		} else {
			getSubscriptionBankAccounts(null).then((subscriptionBankAccounts) =>
				setSubscriptionBankAccounts(subscriptionBankAccounts)
			);
		}
	}, []);

	const validateCourtPayInfo = () => {
		if (!useMpesa && !useBankAccount && !useCustomPayInfo) {
			issueWarnMessage(
				"Must select either Mpesa or Bank account or Custom Pay Info and add details"
			);
			return false;
		}
		if (useMpesa) {
			// if paybill given then short code must be there & vice versa
			if (
				isEmptyString(mpesaPaybill) &&
				!isEmptyString(mpesaBusinessShortcode)
			) {
				issueWarnMessage(
					"Must provide a paybill number when a shortcode is given"
				);
				return false;
			}
			if (
				!isEmptyString(mpesaPaybill) &&
				isEmptyString(mpesaBusinessShortcode)
			) {
				issueWarnMessage(
					"Must provide a business short code when a paybill is already provided"
				);
				return false;
			}
			if (!isEmptyString(mpesaPaybill) && mpesaPaybill.length > 10) {
				issueWarnMessage(
					"MPESA Paybill cannot be more than 10 characters"
				);
				return false;
			}
			if (
				!isEmptyString(mpesaBusinessShortcode) &&
				mpesaBusinessShortcode.length > 10
			) {
				issueWarnMessage(
					"MPESA Business Shortcode cannot be more than 10 characters"
				);
				return false;
			}
		}

		if (isNullUndefined(mpesaPassKey)) {
			setMpesaPassKey("");
		}
		if (isNullUndefined(mpesaKey)) {
			setMpesaKey("");
		}
		if (isNullUndefined(mpesaSecret)) {
			setMpesaSecret("");
		}
		if (isNullUndefined(apiInitiatorUsername)) {
			setApiInitiatorUsername("");
		}
		if (isNullUndefined(apiInitiatorPassword)) {
			setApiInitiatorPassword("");
		}
		if (isNullUndefined(nominatedNumber)) {
			setNominatedNumber("");
		}

		if (useBankAccount) {
			if (isEmptyString(bankAccountId)) {
				issueWarnMessage(
					"Must select a bank account when 'use a bank account' is checked"
				);
				return false;
			}
		}

		if (useCustomPayInfo) {
			if (isEmptyString(customPayInstruction)) {
				issueWarnMessage("Must provide a custom payment instruction");
				return false;
			}
			if (customPayInstruction.length > 400) {
				issueWarnMessage(
					"Custom payment instruction cannot be more than 400 characters"
				);
			}
			if (useMpesa) {
				issueWarnMessage(
					"Cannot use MPESA with custom payment info at the same time"
				);
			}
			if (useBankAccount) {
				issueWarnMessage(
					"Cannot use bank account with custom payment info at the same time"
				);
			}
		}

		if(showContactOnInvoice) {
      if(isEmptyString(invoiceContact) && isEmptyString(invoiceEmail)){
        issueWarnMessage("Must provide at least one contact(email or phone number)");
        return false;
      }

      if(!isEmptyString(invoiceContact)) {
        const regex = /^(07\d{8}|01\d{8}|\+2547\d{8}|\+2541\d{8})$/;
        if (!regex.test(invoiceContact)) {
          issueWarnMessage("Invalid phone number format");
          return false;
        }
      }

      if(!isEmptyString(invoiceEmail)) {
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!regex.test(invoiceEmail)) {
          issueWarnMessage("Invalid email address format");
					return false
        }
      }
    }
		return true;
	};

	const submit = () => {
		if (isEmptyString(name)) {
			issueWarnMessage("The court must have a name!!");
			return;
		}

		const sendData = {
			id: id ?? null,
			name: name,
			description: description,
			courtPayInfo: {
				useBankAccount: useBankAccount,
				useMpesa: useMpesa,
				mpesaPaybill: mpesaPaybill,
				mpesaBusinessShortcode: mpesaBusinessShortcode,
				bankAccountId: bankAccountId,
				payInvoice: payInvoice,
				mpesaKey: mpesaKey,
				mpesaSecret: mpesaSecret,
				mpesaPassKey: mpesaPassKey,
				apiInitiatorUsername: apiInitiatorUsername,
				apiInitiatorPassword: apiInitiatorPassword,
				nominatedNumber: nominatedNumber,
				hideBalanceBroughtForward: hideBalanceBroughtForward,
				hideOutstandingAmount: hideOutstandingAmount,
				disableSmsCommunication: disableSmsCommunication,
				attachStatement: attachStatement,
				useCustomPayInfo: useCustomPayInfo,
				customPayInstruction: customPayInstruction,
				invoicePhone: invoiceContact,
				invoiceEmail: invoiceEmail,
			},
		};
		if (validateCourtPayInfo()) {
			saveCourt(sendData).then((response) => {
				issueResponseMessage(response);
				props.setCourtModal(false);
			});
		}
	};

	const clearMpesa = () => {
		setMpesaPaybill("");
		setMpesaBusinessShortcode("");
		setMpesaKey("");
		setMpesaSecret("");
		setMpesaPassKey("");
		setApiInitiatorUsername("");
		setApiInitiatorPassword("");
		setNominatedNumber("");
	};

	const clearBankAccount = () => {
		setBankAccountId("");
	};

	const clearCustomPayInfo = () => {
		setCustomPayInstruction("");
	};

	const handleInvoiceContactChange = (event) => {
    const phoneNumber = event.target.value;
    setInvoiceContact(phoneNumber)
  };

  const handleInvoiceEmailChange = (event) => {
    const email = event.target.value;
    setInvoiceEmail(email);
  };

	return (
		<ModalContainerModule
			size="specialEditPropertyUnit"
			accept={submit}
			cancel={() => props.setCourtModal(false)}
			openModal={props.courtModal}
			modalTitle={
				isNullUndefined(props.court.id)
					? "Add Court"
					: `Edit Court: ${props.court.name}`
			}
			acceptButtonText={
				isNullUndefined(props.court.id) ? "Save" : "Update"
			}
		>
			<ResponsiveRow
				sx={{ width: "100%", height: "auto", alignItems: "center" }}
			>
				<ResponsiveRow container sx={{ width: "100%", height: "auto" }}>
					<Typography variant="h3" component="h2">
						Court Details
					</Typography>
					<Typography variant="h6" color="text.secondary">
						&nbsp;&nbsp;&nbsp;(Use the form below to enter the
						details of an individual court)
					</Typography>
				</ResponsiveRow>
				<FormControl
					sx={{
						width: { xs: "100%", lg: "33.3%" },
						marginBottom: "10px",
					}}
				>
					<InputLabel>Name</InputLabel>
					<OutlinedInput
						label="Name"
						value={name}
						onChange={(e) => setName(e.target.value)}
						sx={{ width: { xs: "100%", lg: "90%" } }}
					/>
				</FormControl>
				<FormControl
					sx={{
						width: { xs: "100%", lg: "33.3%" },
						marginBottom: "10px",
					}}
				>
					<InputLabel>Description</InputLabel>
					<InputCharactersCountWrapper value={description ?? ""} maxLength={180} width={{ xs: "100%", md: "90%" }}>
						<OutlinedInput
							label="Description"
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							sx={{ width: "100%" }}
						/>
					</InputCharactersCountWrapper>
				</FormControl>
			</ResponsiveRow>
			<ResponsiveRow sx={{ width: "100%", height: "auto" }}>
				<Alert severity="info" sx={{ width: "100%" }}>
					<AlertTitle>
						Court Payment Information and Settings
					</AlertTitle>
					This payment information will be sent out on the invoices so
					that customers can make payments using the appropriate
					service. Leave it blank if you want no information to appear
					on the invoice.
					<Permit services="HOA">
						<br />
						When pay to invoice/Charge is turned on, payment
						received would be used to offset the invoice/Charge in
						reference. <br />
						When hide balance brought forward is turned on,
						previously unpaid sum would be hidden on the
						invoice/Charge.
					</Permit>
				</Alert>

				<br />

				<ResponsiveRow sx={{ width: "100%" }}>
					<FormControlLabel
						label="Use Integrated M-PESA"
						control={
							<Checkbox
								checked={useMpesa}
								value={"useMpesa"}
								onChange={(event) => {
									if (useCustomPayInfo) {
										issueWarnMessage(
											"Cannot use integrated M-PESA and custom pay info at the same time"
										);
										if (event.target.checked) return;
									}
									if (!useBankAccount) {
										clearBankAccount();
									}
									clearCustomPayInfo();
									setUseMpesa(event.target.checked);
								}}
								inputProps={{ "aria-label": "controlled" }}
							/>
						}
					/>
					<Permit services="CORE,HOA,LEAN,PREMIUM,METER,MAINT">
						<FormControlLabel
							label="Use Integrated Bank Account"
							control={
								<Checkbox
									checked={useBankAccount}
									value={"useBankAccount"}
									onChange={(event) => {
										if (useCustomPayInfo) {
											issueWarnMessage(
												"Cannot use integrated bank account and custom pay info at the same time"
											);
											if (event.target.checked) return;
										}
										if (!useMpesa) {
											clearMpesa();
										}
										clearCustomPayInfo();
										setUseBankAccount(event.target.checked);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>
					</Permit>
					<Permit services="CORE,HOA,LEAN,PREMIUM,METER,MAINT">
						<FormControlLabel
							label="Use Custom Pay Instructions"
							control={
								<Checkbox
									checked={useCustomPayInfo}
									value={"useCustomPayInfo"}
									onChange={(event) => {
										if (useMpesa) {
											issueWarnMessage(
												"Cannot use integrated mpesa and custom pay info at the same time"
											);
											if (event.target.checked) return;
										} else if (useBankAccount) {
											issueWarnMessage(
												"Cannot use integrated bank account and custom pay info at the same time"
											);
											if (event.target.checked) return;
										}

										clearBankAccount();
										clearMpesa();
										setUseCustomPayInfo(
											event.target.checked
										);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>

						<FormControlLabel
							label="Disable SMS Communication"
							control={
								<Switch
									checked={disableSmsCommunication}
									onChange={(event) => {
										setDisableSmsCommunication(
											event.target.checked
										);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>

						<FormControlLabel
							label="Attach Statement on Invoicing"
							control={
								<Switch
									checked={attachStatement}
									onChange={(event) => {
										setAttachStatement(
											event.target.checked
										);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>
					</Permit>
				</ResponsiveRow>
				<Permit services="HOA">
					<ResponsiveRow sx={{ width: "100%" }}>
						<FormControlLabel
							label="Hide Balance Brought Forward"
							control={
								<Switch
									checked={hideBalanceBroughtForward}
									onChange={(event) => {
										setHideBalanceBroughtForward(
											event.target.checked
										);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>
							<FormControlLabel
								label="Hide Receipt Outstanding Amount"
								control={
									<Switch
										checked={hideOutstandingAmount}
										onChange={(event) => {
											setHideOutstandingAmount(
												event.target.checked
											);
										}}
										inputProps={{ "aria-label": "controlled" }}
									/>
								}
							/>
						<FormControlLabel
							label="Pay Invoice/Charge"
							control={
								<Switch
									checked={payInvoice}
									onChange={(event) => {
										setPayInvoice(event.target.checked);
									}}
									inputProps={{ "aria-label": "controlled" }}
								/>
							}
						/>

						{/* <FormControlLabel
              label="Show HOA Balance Table"
              control={
                <Switch
                  checked={showBalance}
                  onChange={(event) => {
                    setShowBalance(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            /> */}
						<br />
					</ResponsiveRow>
				</Permit>
				<ResponsiveRow sx={{ width: "100%" }}>
					{useBankAccount ? (
						<FormControl
							item
							sx={{
								width: { xs: "100%", lg: "33.3%" },
								marginBottom: "10px",
							}}
						>
							<InputLabel>Select Bank Account</InputLabel>
							<Select
								label="Select Bank Account"
								sx={{ width: { xs: "100%", md: "90%" } }}
								id={"bankdetails"}
								defaultValue=""
								required={useBankAccount && true}
								name={"bankdetails"}
								value={bankAccountId}
								onChange={(event) =>
									setBankAccountId(event.target.value)
								}
							>
								{subscriptionBankAccounts !== undefined &&
								subscriptionBankAccounts.length > 0 ? (
									subscriptionBankAccounts.map(
										(bankAcc, i) => (
											<MenuItem
												key={i}
												value={bankAcc.value}
											>
												{bankAcc.label}
											</MenuItem>
										)
									)
								) : (
									<MenuItem sx={{ width: "100%" }}>
										No Results Found
									</MenuItem>
								)}
							</Select>
						</FormControl>
					) : (
						""
					)}

					{useMpesa ? (
						<ResponsiveRow container sx={{ width: "100%" }}>
							<Grid
								item
								sx={{ width: "100%", marginBottom: "10px" }}
							>
								<Permit services="CORE,HOA,LEAN,PREMIUM,METER,MAINT">
									<Alert severity="warning">
										If you want to use M-PESA and don't
										provide a Paybill & Business Shortcode,
										you will be defaulted to using the
										Smartkodi paybill
									</Alert>
								</Permit>
								<Permit services="BLWTR">
									<Alert severity="warning">
										M-PESA Till number and short code is
										request to enable payment through buy
										goods
									</Alert>
								</Permit>
							</Grid>
							<FormControl
								item
								sx={{
									width: { xs: "100%", lg: "50%" },
									marginBottom: "10px",
								}}
							>
								{!isNullUndefined(props.selectedProperty) &&
									isNullUndefined(
										props.selectedProperty.id
									) && (
										<InputLabel>M-PESA Paybill</InputLabel>
									)}
								<Permit services="CORE,HOA,LEAN,PREMIUM,METER,MAINT">
									<InputLabel>M-PESA Paybill</InputLabel>
								</Permit>
								<Permit services="BLWTR">
									<InputLabel>M-PESA Till</InputLabel>
								</Permit>
								<OutlinedInput
									label="M-PESA Paybill"
									sx={{ width: { xs: "100%", md: "90%" } }}
									type="paybill"
									id="paybill"
									required={useMpesa && true}
									color="secondary"
									value={mpesaPaybill}
									onChange={(event) => {
										setMpesaPaybill(event.target.value);
									}}
									inputProps={
										<TextField
											sx={{
												width: {
													xs: "100%",
													md: "90%",
												},
											}}
										/>
									}
								/>
							</FormControl>
							<FormControl
								item
								sx={{
									width: { xs: "100%", lg: "50%" },
									marginBottom: "10px",
								}}
							>
								<InputLabel>M-PESA Business Code</InputLabel>
								<OutlinedInput
									label="M-PESA Business Code"
									sx={{ width: { xs: "100%", md: "90%" } }}
									type="businessCode"
									id="businessCode"
									color="secondary"
									required={useMpesa && true}
									value={mpesaBusinessShortcode}
									onChange={(event) => {
										setMpesaBusinessShortcode(
											event.target.value
										);
									}}
									inputProps={
										<TextField
											sx={{
												width: {
													xs: "100%",
													md: "90%",
												},
											}}
										/>
									}
								/>
							</FormControl>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>M-PESA Key</InputLabel>
									<OutlinedInput
										label="M-PESA Key"
										sx={{
											width: { xs: "100%", md: "90%" },
										}}
										type="key"
										id="key"
										color="secondary"
										value={mpesaKey}
										onChange={(event) => {
											setMpesaKey(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: {
														xs: "100%",
														md: "90%",
													},
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>M-PESA Secret</InputLabel>
									<OutlinedInput
										sx={{
											width: { xs: "100%", md: "90%" },
										}}
										type="secret"
										id="secret"
										label="M-PESA Secret"
										color="secondary"
										value={mpesaSecret}
										onChange={(event) => {
											setMpesaSecret(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: {
														xs: "100%",
														md: "90%",
													},
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>
										M-PESA Pass Key (for STK and Transaction
										Query)
									</InputLabel>
									<OutlinedInput
										sx={{ width: "90%" }}
										type="passKey"
										label="M-PESA Pass Key (for STK and Transaction Query)"
										id="passKey"
										color="secondary"
										value={mpesaPassKey}
										onChange={(event) => {
											setMpesaPassKey(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: {
														xs: "100%",
														md: "90%",
													},
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>API Initiator Username</InputLabel>
									<OutlinedInput
										label="M-PESA Key"
										sx={{ width: { xs: "100%", md: "90%" } }}
										type="key"
										id="key"
										color="secondary"
										value={apiInitiatorUsername}
										onChange={(event) => {
											setApiInitiatorUsername(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: { xs: "100%", md: "90%" },
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>API Initiator Password (Plain Text)</InputLabel>
									<OutlinedInput
										label="M-PESA Key"
										sx={{ width: { xs: "100%", md: "90%" } }}
										type="key"
										id="key"
										color="secondary"
										value={apiInitiatorPassword}
										onChange={(event) => {
											setApiInitiatorPassword(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: { xs: "100%", md: "90%" },
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
							<Permit roles={"SYSAD"}>
								<FormControl
									item
									sx={{
										width: { xs: "100%", lg: "50%" },
										marginBottom: "10px",
									}}
								>
									<InputLabel>Nominated Number</InputLabel>
									<OutlinedInput
										label="M-PESA Key"
										sx={{ width: { xs: "100%", md: "90%" } }}
										type="key"
										id="key"
										color="secondary"
										value={nominatedNumber}
										onChange={(event) => {
											setNominatedNumber(event.target.value);
										}}
										inputProps={
											<TextField
												sx={{
													width: { xs: "100%", md: "90%" },
												}}
											/>
										}
									/>
								</FormControl>
							</Permit>
						</ResponsiveRow>
					) : (
						""
					)}

					{useCustomPayInfo && (
						<ResponsiveRow container sx={{ width: "100%" }}>
							<Grid
								item
								sx={{ width: "80%", marginBottom: "10px" }}
							>
								<Permit services="CORE,HOA,LEAN,PREMIUM,METER,MAINT">
									<Alert severity="warning">
										If you want to use Custom Payment
										Instructions, provide payment
										instructions. These payment instructions
										will be attached to the invoice. <br />
										Example Instruction: e.g., 'Paybill
										Number: 123123 | Account: Use your unit
										name.'”
									</Alert>
								</Permit>
							</Grid>
							<FormControl
								item
								sx={{
									width: { xs: "100%", lg: "50%" },
									marginBottom: "10px",
								}}
							>
								<InputLabel>
									Custom Payment Instruction
								</InputLabel>
								<OutlinedInput
									label="Custom Payment Instruction"
									sx={{ width: { xs: "100%", md: "90%" } }}
									type="customPaymentInstruction"
									id="customPaymentInstruction"
									required={useCustomPayInfo && true}
									color="secondary"
									value={customPayInstruction}
									onChange={(event) => {
										setCustomPayInstruction(
											event.target.value
										);
									}}
									inputProps={
										<TextField
											sx={{
												width: {
													xs: "100%",
													md: "90%",
												},
											}}
										/>
									}
								/>
							</FormControl>
						</ResponsiveRow>
					)}
				</ResponsiveRow>


        <FormControlLabel
          label="Display Contacts on Invoice"
          control={
            <Checkbox
              checked={showContactOnInvoice}
              value={"showContactOnInvoice"}
              onChange={(event) => setShowContactOnInvoice(event.target.checked)}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
        />
        {showContactOnInvoice && (
          <ResponsiveRow sx={{ width: "100%" }}>
            <Alert severity="info" sx={{ width: "80%", marginBottom: "10px" }}>
              <AlertTitle>Contact Details Displayed on Invoices</AlertTitle>
              The details provided here will be displayed to the customers on their invoices.
            </Alert>
            <FormControl
              item
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              <InputLabel>Phone Number</InputLabel>
              <OutlinedInput
                id="invoiceContact"
                label="Phone Number"
                sx={{
                  width: { xs: "100%", md: "90%" },
                }}
                onChange={handleInvoiceContactChange}
                required={true}
                value={invoiceContact}
                inputProps={
                  <TextField
                    sx={{
                      width: { xs: "100%", md: "90%" },
                    }}
                  />
                }
              />
            </FormControl>
            <FormControl
              item
              sx={{
                width: { xs: "100%", lg: "33.3%" },
                marginBottom: "10px",
              }}
            >
              <InputLabel>Email</InputLabel>
              <OutlinedInput
                id="invoiceEmail"
                label="Email"
                sx={{
                  width: { xs: "100%", md: "90%" },
                }}
                onChange={handleInvoiceEmailChange}
                required={true}
                value={invoiceEmail}
                inputProps={
                  <TextField
                    sx={{
                      width: { xs: "100%", md: "90%" },
                    }}
                  />
                }
              />
            </FormControl>
          </ResponsiveRow>
        )}
			</ResponsiveRow>
		</ModalContainerModule>
	);
}
